import { convertToISODate } from "@/Utils";
import ZInputNumber from "@atoms/ZInputNumber";
import ZSelect from "@atoms/ZSelect";
import { MergeTagVariableDataType } from "@/Contracts/Documents";
import ZDatePicker from "@molecules/ZDatePicker";
import ZInput from "@molecules/ZInput";
import { IZInputFieldForMergeTagProps } from "./interface";
import React from "react";
import moment from "moment";

const ZInputFieldForMergeTag: React.FC<IZInputFieldForMergeTagProps> = ({
	value,
	onChange,
	mergeTag
}) => {
	if (!mergeTag) return null;
	switch (mergeTag.data_type) {
		case MergeTagVariableDataType.DATE:
			return (
				<ZDatePicker
					className="w-full"
					value={value ? moment(value) : null}
					onChange={value => onChange(convertToISODate(value) ?? "")}
				/>
			);
		case MergeTagVariableDataType.DOUBLE:
			return (
				<ZInputNumber
					placeholder="Enter Value"
					width="full"
					value={value ? Number(value) : 0}
					onChange={value => onChange(value)}
				/>
			);
		case MergeTagVariableDataType.NUMBER:
			return (
				<ZInputNumber
					placeholder="Enter Value"
					width="full"
					min={0}
					step={1}
					value={value ? Number(value) : 0}
					onChange={value => onChange(value)}
				/>
			);
		case MergeTagVariableDataType.DROPDOWN:
			return (
				<ZSelect
					placeholder="Select Value"
					className="w-full"
					selectOptions={mergeTag?.allowed_values ?? []}
					value={value}
					onChange={value => onChange(`${value}`)}
				/>
			);
		default:
			return (
				<ZInput
					width="full"
					placeholder="Enter Value"
					value={value}
					onChange={e => {
						onChange(e.target.value);
					}}
				/>
			);
	}
};

export default ZInputFieldForMergeTag;
